const localeRegistry = require('../i18n/locales.generated.json');
const {
    parseBuildTarget,
    visibleManagedLocales,
} = require('../scripts/i18n/build-target-contract.cjs');

const SECTIONS = new Set(['news', 'newsletter']);

function resolveStaticArticlePathPrefix(
    locale = process.env.EXPO_PUBLIC_PZ_I18N_LOCALE || localeRegistry.sourceLocale,
    registry = localeRegistry,
    // Expo only inlines direct process.env.EXPO_PUBLIC_* references. Passing
    // process.env itself loses these values in the browser and treats review
    // builds as production, blocking planned Spanish after client navigation.
    environment = {
        EXPO_PUBLIC_PZ_I18N_BUILD_TARGET: process.env.EXPO_PUBLIC_PZ_I18N_BUILD_TARGET,
        EXPO_PUBLIC_PZ_I18N_REVIEW_ARTIFACT: process.env.EXPO_PUBLIC_PZ_I18N_REVIEW_ARTIFACT,
    }
) {
    if (locale === registry.sourceLocale) return '';
    if ((registry.testLocales || []).some(({ tag }) => tag === locale)) return '';

    const managed = registry.locales.find(({ tag }) => tag === locale);
    if (!managed) return '';
    const target = parseBuildTarget(environment.EXPO_PUBLIC_PZ_I18N_BUILD_TARGET);
    const reviewArtifact = environment.EXPO_PUBLIC_PZ_I18N_REVIEW_ARTIFACT === 'non-promotable';
    const visible = visibleManagedLocales({
        ...registry,
        defaultLocale: registry.defaultLocale || registry.sourceLocale,
    }, target, reviewArtifact)
        .some(({ tag }) => tag === locale);
    if (!visible) return '';
    if (
        typeof managed.pathPrefix !== 'string'
        || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(managed.pathPrefix)
    ) {
        throw new Error(`Static article locale ${locale} requires a safe non-empty pathPrefix`);
    }
    return managed.pathPrefix;
}

function staticArticleAssetPath(
    section,
    relativePath,
    locale = process.env.EXPO_PUBLIC_PZ_I18N_LOCALE || localeRegistry.sourceLocale,
    registry = localeRegistry
) {
    if (!SECTIONS.has(section)) throw new Error(`Unsupported static article section: ${section}`);
    if (
        typeof relativePath !== 'string'
        || !relativePath
        || relativePath.startsWith('/')
        || relativePath.split('/').includes('..')
    ) {
        throw new Error(`Unsafe static article asset path: ${relativePath}`);
    }
    const prefix = resolveStaticArticlePathPrefix(locale, registry);
    return `/static/${section}/${prefix ? `${prefix}/` : ''}${relativePath}`;
}

module.exports = {
    resolveStaticArticlePathPrefix,
    staticArticleAssetPath,
};
